(function () {
  "use strict";

  angular.module("sempraWebapp").component("workingSchedules", {
    templateUrl:
      "app/workingSchedulesAndHolidays/workingSchedules/workingSchedules.html",
    controller: workingSchedules,
    bindings: {
      workingSchedulesData: "<",
      allDayCheckBoxData: "<",
      siteId: "<",
      refresh: "&"
    },
    controllerAs: "vm"
  });

  function workingSchedules(workingSchedulesActions, $filter) {
    var vm = this;

    vm.scheduleList = [];

    vm.dayStateOptions = [
      { value: "NONE", label: "WORKING_HOURS_CUSTOM" },
      { value: "OPEN", label: "OPENED_24" },
      { value: "CLOSE", label: "CLOSED_24" }
    ];

    vm.isDayCustom = function(day) {
      return !day.state24h || day.state24h === "NONE";
    };

    vm.isFromGreaterThanTo = function(day) {
      if (!vm.isDayCustom(day) || vm.allDayCheckBoxData !== "NONE") {
        return false;
      }
      if (day.hoursFrom == null || day.minutesFrom == null ||
          day.hoursTo == null || day.minutesTo == null) {
        return false;
      }
      return (day.hoursFrom * 60 + day.minutesFrom) > (day.hoursTo * 60 + day.minutesTo);
    };

    vm.hasInvalidFromTo = function() {
      if (!vm.scheduleList) return false;
      for (var i = 0; i < vm.scheduleList.length; i++) {
        if (vm.isFromGreaterThanTo(vm.scheduleList[i])) {
          return true;
        }
      }
      return false;
    };

    vm.$onInit = function () {};

    vm.$onChanges = function (changes) {
      if (changes.workingSchedulesData) {
        vm.scheduleList = changes.workingSchedulesData.currentValue;
        if(changes.workingSchedulesData.currentValue.length !== 0) {
          vm.scheduleList.forEach(function(item) {
            item.dayString = $filter('codeToDayName')(item.day);
          });
        }
      } else if (changes.siteId) {
        vm.siteId = changes.siteId.currentValue;
      }
    };

    vm.updateSchedules = function () {
      var data = {
        days: vm.scheduleList,
        state24h: vm.allDayCheckBoxData
      }
      workingSchedulesActions
        .updateWorkingSchedules(vm.siteId, data)
        .then(function () {});
    };

  }
})();
